export default "__VITE_ASSET___9tn_zoG__"